import React from 'react';
import { Album } from "../tile-album";
import { SortOrder } from './enums';
import { GalleryWrapper, NoAttachments } from './style';
export const NO_ATTACHMENTS = 'No attachments';
const translateString = (key, translateFn) => translateFn ? translateFn(key) : key;
const sortAlbumsByHeader = (albums, sortOrder) => {
    sortOrder === SortOrder.Ascending
        ? albums.sort((albumOne, albumTwo) => albumOne.header.localeCompare(albumTwo.header))
        : albums.sort((albumOne, albumTwo) => albumTwo.header.localeCompare(albumOne.header));
};
export const Gallery = (props) => {
    const renderAlbums = () => {
        const albums = [...props.albums];
        {
            !props.ignoreSorting &&
                sortAlbumsByHeader(albums, props.groupSortOrder || SortOrder.Ascending);
        }
        return albums.map((album) => (React.createElement(Album, { key: album.id, id: `album-${album.id}`, groupName: album.groupName, mode: props.mode, header: album.header, subHeader: album.subHeader, tiles: album.tiles, shouldShowGroup: props.shouldShowGroup, isSelectModeOn: props.isSelectModeOn, onTileClick: props.onTileClick, translateFn: props.translateFn, onUpdateTileDescription: props.onUpdateTileDescription, shouldShowThumbnailForPdf: props.shouldShowThumbnailForPdf, tilesGap: props.tilesGap, panelBackgroundColor: props.panelBackgroundColor, smallTileHeight: props.smallTileHeight, smallTileWidth: props.smallTileWidth, onSelectAll: props.onSelectAll, onDeselectAll: props.onDeselectAll })));
    };
    return (React.createElement(GalleryWrapper, { id: `gallery-wrapper-${props.id}`, isSelectModeOn: props.isSelectModeOn }, props.albums.length ? (renderAlbums()) : (React.createElement(NoAttachments, null, translateString(NO_ATTACHMENTS, props.translateFn)))));
};
Gallery.defaultProps = {
    shouldShowThumbnailForPdf: false
};
//# sourceMappingURL=Gallery.js.map